<template>
  <div _tmplitem="252" class="dv-full-screen-container" :style="css">
    <div _tmplitem="252"
      style="position: absolute;--animation-linear:1;--animation-type:ease;width:1920px;height:1080px; background-image: url(/img1948914776579035137/charts-img-db_id_2p0mcnzpe7i000.jpg) !important;background-size:100% 100%;    background-repeat:no-repeat;"
      class="div-full-screen">
      <div _tmplitem="252" v-if="readDataPermission.gropn3cq" class="gropn3cq "
        style="overflow: hidden; width: 191px; height: 56px;top: 484px; left: 1509px;position: absolute; z-index: 1037;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="252" class=""
          style=" width: 191px; height: 56px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="194" v-if="readDataPermission.numlhg9" class="bigitem numlhg9 "
            style="top: 6px; left: 91px; position: absolute;width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 104;pointer-events: auto;  ">
            <div _tmplitem="194" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:14px ;color:rgba(14, 191, 168, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <digitalflop _tmplitem="190" ref="numlhg9" :num="fromData.numlhg9" content="{nt}万吨" :w="100" :h="40"
                :len="0"
                cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:14px ;color:rgba(14, 191, 168, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              </digitalflop>
            </div>
          </div>
          <div _tmplitem="194" v-if="readDataPermission.nxiconsqa4l" class="bigitem nxiconsqa4l "
            style="top: 6px; left: 9px; position: absolute;width: 50px; height: 50px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
            <div _tmplitem="194" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:30px ;color:rgba(14, 191, 168, 1) ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <nxsvgicon _tmplitem="191" class-name="el-icon-truck" icon-class="el-icon-truck"
                style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:30px ;color:rgba(14, 191, 168, 1) ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              </nxsvgicon>
            </div>
          </div>
          <div _tmplitem="194" v-if="readDataPermission.titlehn3l" class="bigitem titlehn3l "
            style="top: 6px; left: 52px; position: absolute;width: 56px; height: 38px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="194" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:14px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="192" ref="titlehn3l" :w="56" :h="38" :val="fromData.titlehn3l"
                cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:14px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              </titlecontrol>
            </div>
          </div>
          <div _tmplitem="194" v-if="readDataPermission.img9e6m" class="bigitem img9e6m "
            style="top: 0px; left: 0px; position: absolute;width: 164px; height: 51px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="194" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="193" url="/img1948914776579035137/a6df0979-156d-4ab7-9c15-04e685feacfa.png" w="164"
                h="51" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.gropxcto" class="gropxcto "
        style="overflow: hidden; width: 185px; height: 58px;top: 482px; left: 1709px;position: absolute; z-index: 1036;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="252" class=""
          style=" width: 185px; height: 58px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="199" v-if="readDataPermission.nummeaj" class="bigitem nummeaj "
            style="top: 8px; left: 85px; position: absolute;width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 104;pointer-events: auto;  ">
            <div _tmplitem="199" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:14px ;color:rgba(132, 191, 14, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <digitalflop _tmplitem="195" ref="nummeaj" :num="fromData.nummeaj" content="{nt}万吨" :w="100" :h="40"
                :len="0"
                cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:14px ;color:rgba(132, 191, 14, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              </digitalflop>
            </div>
          </div>
          <div _tmplitem="199" v-if="readDataPermission.img3r9a" class="bigitem img3r9a "
            style="top: 0px; left: 0px; position: absolute;width: 164px; height: 51px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
            <div _tmplitem="199" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;filter:saturate(1) contrast(0.36) hue-rotate(261deg) brightness(1) blur(0px);transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="196" url="/img1948914776579035137/a6df0979-156d-4ab7-9c15-04e685feacfa.png" w="164"
                h="51" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
          <div _tmplitem="199" v-if="readDataPermission.titlea1v3" class="bigitem titlea1v3 "
            style="top: 7px; left: 47px; position: absolute;width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="199" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="197" ref="titlea1v3" :w="100" :h="40" :val="fromData.titlea1v3"
                cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              </titlecontrol>
            </div>
          </div>
          <div _tmplitem="199" v-if="readDataPermission.nxiconsjhwa" class="bigitem nxiconsjhwa "
            style="top: 8px; left: 10px; position: absolute;width: 50px; height: 50px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="199" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:30px ;color:rgba(132, 191, 14, 1) ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <nxsvgicon _tmplitem="198" class-name="fa fa-bus" icon-class="fa fa-bus"
                style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:30px ;color:rgba(132, 191, 14, 1) ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              </nxsvgicon>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.vuecommq1ys" class="bigitem vuecommq1ys bigechartitem"
        style="top: 274px; left: 1215px;position: absolute; width: 238px; height: 290px; transform: translate(0px, 0px); z-index: 1035;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <vuecommq1ys ref="vuecommq1ys"
            cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          </vuecommq1ys>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.titledhj5" class="bigitem titledhj5 "
        style="top: 323px; left: 1758px;position: absolute; width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 1034;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <titlecontrol _tmplitem="201" ref="titledhj5" :w="100" :h="40" :val="fromData.titledhj5" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);    color: rgb(255, 255, 255);
  height: 37px;
  font-size: 18px;
  text-align: center;
  background: rgba(40, 44, 52, 0);
  font-family: YiPing;
  font-weight: bold;
  line-height: 35px;"></titlecontrol>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.title1cpv" class="bigitem title1cpv "
        style="top: 322px; left: 1532px;position: absolute; width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 1033;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <titlecontrol _tmplitem="202" ref="title1cpv" :w="100" :h="40" :val="fromData.title1cpv" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);    color: rgb(255, 255, 255);
  height: 37px;
  font-size: 18px;
  text-align: center;
  background: rgba(40, 44, 52, 0);
  font-family: YiPing;
  font-weight: bold;
  line-height: 35px;"></titlecontrol>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.customcotrlo3wt" class="bigitem customcotrlo3wt bigechartitem"
        style="top: 761px; left: 1498px;position: absolute; width: 391px; height: 59px; transform: translate(0px, 0px); z-index: 1032;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <custom1948972425559461890 ref="customcotrlo3wt" w="391" h="59" :iscomzoom="true" :initwidth="0"
            :initheight="0" comid="1948972425559461890" title="今日出库清单"></custom1948972425559461890>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.customcotrlz5be" class="bigitem customcotrlz5be bigechartitem"
        style="top: 443px; left: 1488px;position: absolute; width: 391px; height: 59px; transform: translate(0px, 0px); z-index: 1031;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <custom1948972425559461890 ref="customcotrlz5be" w="391" h="59" :iscomzoom="true" :initwidth="0"
            :initheight="0" comid="1948972425559461890" title="今日物流分析"></custom1948972425559461890>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.customcotrlq1yv" class="bigitem customcotrlq1yv bigechartitem"
        style="top: 118px; left: 1512px;position: absolute; width: 391px; height: 59px; transform: translate(0px, 0px); z-index: 1030;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <custom1948972425559461890 ref="customcotrlq1yv" w="391" h="59" :iscomzoom="true" :initwidth="0"
            :initheight="0" comid="1948972425559461890" title="原材料库存"></custom1948972425559461890>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.customcotrlhb2t" class="bigitem customcotrlhb2t bigechartitem"
        style="top: 766px; left: 733px;position: absolute; width: 391px; height: 59px; transform: translate(0px, 0px); z-index: 1029;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <custom1948972425559461890 ref="customcotrlhb2t" w="391" h="59" :iscomzoom="true" :initwidth="0"
            :initheight="0" comid="1948972425559461890" title="今日生产情况"></custom1948972425559461890>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.customcotrlbwjw" class="bigitem customcotrlbwjw bigechartitem"
        style="top: 761px; left: 30px;position: absolute; width: 391px; height: 59px; transform: translate(0px, 0px); z-index: 1028;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <custom1948972425559461890 ref="customcotrlbwjw" w="391" h="59" :iscomzoom="true" :initwidth="0"
            :initheight="0" comid="1948972425559461890" title="今日生产清单"></custom1948972425559461890>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.customcotrlhlag" class="bigitem customcotrlhlag bigechartitem"
        style="top: 441px; left: 32px;position: absolute; width: 391px; height: 59px; transform: translate(0px, 0px); z-index: 1027;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <custom1948972425559461890 ref="customcotrlhlag" w="391" h="59" :iscomzoom="true" :initwidth="0"
            :initheight="0" comid="1948972425559461890" title="今日生产商品占比"></custom1948972425559461890>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.labshoj" class="bigitem labshoj bigechartitem"
        style="top: 118px; left: 41px;position: absolute; width: 391px; height: 59px; transform: translate(0px, 0px); z-index: 1026;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <custom1948972425559461890 ref="labshoj" w="391" h="59" :iscomzoom="true" :initwidth="0" :initheight="0"
            comid="1948972425559461890" title="今日生产情况"></custom1948972425559461890>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.group1832" class="group1832 "
        style="overflow: hidden; width: 112px; height: 115px;top: 121px; left: 1156px;position: absolute; z-index: 1025;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="252" class=""
          style=" width: 112px; height: 115px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="213" v-if="readDataPermission.titles9l7" class="bigitem titles9l7 "
            style="top: 0px; left: 8px; position: absolute;width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
            <div _tmplitem="213" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="210" ref="titles9l7" :w="100" :h="40" :val="fromData.titles9l7" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);    text-align: center;
  font-weight: normal;"></titlecontrol>
            </div>
          </div>
          <div _tmplitem="213" v-if="readDataPermission.numbgm8" class="bigitem numbgm8 "
            style="top: 25px; left: 10px; position: absolute;width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="213" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgb(255, 255, 255) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <digitalflop _tmplitem="211" ref="numbgm8" :num="fromData.numbgm8" content="{nt}%" :w="100" :h="40"
                :len="0" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgb(255, 255, 255) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);    font-size: 22px;
  color: rgb(76, 252, 255);
  text-align: center;
  font-weight: bold;
  font-family: YiPing;"></digitalflop>
            </div>
          </div>
          <div _tmplitem="213" v-if="readDataPermission.img2h99" class="bigitem img2h99 "
            style="top: 21px; left: 0px; position: absolute;width: 112px; height: 94px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="213" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="212" url="/img1948914776579035137/d7d5b9ed-cd3c-4c54-91f1-1e750d3ed55f.png" w="112"
                h="94" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.group3kyz" class="group3kyz "
        style="overflow: hidden; width: 112px; height: 115px;top: 121px; left: 942px;position: absolute; z-index: 1024;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="252" class=""
          style=" width: 112px; height: 115px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="217" v-if="readDataPermission.titlezx47" class="bigitem titlezx47 "
            style="top: 0px; left: 8px; position: absolute;width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
            <div _tmplitem="217" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="214" ref="titlezx47" :w="100" :h="40" :val="fromData.titlezx47" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);    text-align: center;
  font-weight: normal;"></titlecontrol>
            </div>
          </div>
          <div _tmplitem="217" v-if="readDataPermission.numqj42" class="bigitem numqj42 "
            style="top: 25px; left: 10px; position: absolute;width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="217" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgb(255, 255, 255) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <digitalflop _tmplitem="215" ref="numqj42" :num="fromData.numqj42" content="{nt}万吨" :w="100" :h="40"
                :len="0" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgb(255, 255, 255) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);    font-size: 22px;
  color: rgb(76, 252, 255);
  text-align: center;
  font-weight: bold;
  font-family: YiPing;"></digitalflop>
            </div>
          </div>
          <div _tmplitem="217" v-if="readDataPermission.img3672" class="bigitem img3672 "
            style="top: 21px; left: 0px; position: absolute;width: 112px; height: 94px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="217" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="216" url="/img1948914776579035137/d7d5b9ed-cd3c-4c54-91f1-1e750d3ed55f.png" w="112"
                h="94" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.gropaqh0" class="gropaqh0 "
        style="overflow: hidden; width: 156px; height: 156px;top: 580px; left: 508px;position: absolute; z-index: 1023;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="252" class=""
          style=" width: 156px; height: 156px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="220" v-if="readDataPermission.chartla3c" class="bigitem chartla3c "
            style="top: 0px; left: 0px; position: absolute;width: 156px; height: 156px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="220" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <myechart _tmplitem="218" ref="chartla3c" orienttype="horizontal" :echartroll="false"
                :maxechartrollnum="8" :echartrolltime="2" mapcity="" mapcode="" mapurl="" :options="fromData.chartla3c">
              </myechart>
            </div>
          </div>
          <div _tmplitem="220" v-if="readDataPermission.imgc765" class="bigitem imgc765 "
            style="top: 0px; left: 0px; position: absolute;width: 156px; height: 156px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="220" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="219" url="/img1948914776579035137/646b7040-5dc0-4f56-938d-8899b41bb80a.png" w="156"
                h="156" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.groppfau" class="groppfau "
        style="overflow: hidden; width: 121px; height: 115px;top: 121px; left: 721px;position: absolute; z-index: 1022;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="252" class=""
          style=" width: 121px; height: 115px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="224" v-if="readDataPermission.title1ca8" class="bigitem title1ca8 "
            style="top: 0px; left: 8px; position: absolute;width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
            <div _tmplitem="224" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="221" ref="title1ca8" :w="100" :h="40" :val="fromData.title1ca8" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);    text-align: center;
  font-weight: normal;"></titlecontrol>
            </div>
          </div>
          <div _tmplitem="224" v-if="readDataPermission.num7zmh" class="bigitem num7zmh "
            style="top: 25px; left: 1px; position: absolute;width: 120px; height: 40px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="224" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgb(255, 255, 255) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <digitalflop _tmplitem="222" ref="num7zmh" :num="fromData.num7zmh" content="{nt}万吨" :w="120" :h="40"
                :len="0" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgb(255, 255, 255) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);    font-size: 22px;
  color: rgb(76, 252, 255);
  text-align: center;
  font-weight: bold;
  font-family: YiPing;"></digitalflop>
            </div>
          </div>
          <div _tmplitem="224" v-if="readDataPermission.img2cck" class="bigitem img2cck "
            style="top: 21px; left: 0px; position: absolute;width: 112px; height: 94px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="224" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="223" url="/img1948914776579035137/d7d5b9ed-cd3c-4c54-91f1-1e750d3ed55f.png" w="112"
                h="94" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.gropnal7" class="gropnal7 "
        style="overflow: hidden; width: 157px; height: 158px;top: 229px; left: 507px;position: absolute; z-index: 1021;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="252" class=""
          style=" width: 157px; height: 158px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="227" v-if="readDataPermission.chartsrkm" class="bigitem chartsrkm "
            style="top: 0px; left: 0px; position: absolute;width: 156px; height: 156px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="227" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <myechart _tmplitem="225" ref="chartsrkm" orienttype="horizontal" :echartroll="false"
                :maxechartrollnum="8" :echartrolltime="2" mapcity="" mapcode="" mapurl="" :options="fromData.chartsrkm">
              </myechart>
            </div>
          </div>
          <div _tmplitem="227" v-if="readDataPermission.imgxj87" class="bigitem imgxj87 "
            style="top: 2px; left: 1px; position: absolute;width: 156px; height: 156px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="227" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="226" url="/img1948914776579035137/646b7040-5dc0-4f56-938d-8899b41bb80a.png" w="156"
                h="156" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.gropft9g" class="gropft9g "
        style="overflow: hidden; width: 159px; height: 157px;top: 400px; left: 508px;position: absolute; z-index: 1020;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="252" class=""
          style=" width: 159px; height: 157px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="230" v-if="readDataPermission.imgxan0" class="bigitem imgxan0 "
            style="top: 1px; left: 0px; position: absolute;width: 156px; height: 156px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="230" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="228" url="/img1948914776579035137/646b7040-5dc0-4f56-938d-8899b41bb80a.png" w="156"
                h="156" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
          <div _tmplitem="230" v-if="readDataPermission.chart7ytr" class="bigitem chart7ytr "
            style="top: 0px; left: 3px; position: absolute;width: 156px; height: 156px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="230" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <myechart _tmplitem="229" ref="chart7ytr" orienttype="horizontal" :echartroll="false"
                :maxechartrollnum="8" :echartrolltime="2" mapcity="" mapcode="" mapurl="" :options="fromData.chart7ytr">
              </myechart>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.charttoolgybg" class="bigitem charttoolgybg "
        style="top: 163px; left: 446px;position: absolute; width: 1023px; height: 603px; transform: translate(0px, 0px); z-index: 1019;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <baseechart _tmplitem="231" ref="charttoolgybg" :val="fromData.charttoolgybg" mapcity="china,430000"
            mapcode="430000" orienttype="horizontal" :echartroll="false" :maxechartrollnum="8" :echartrolltime="2"
            :configechart="controlData.charttoolgybg" :w="1023" :h="603" echartcode="widgetLineMap"></baseechart>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.scrollingtableyznd" class="bigitem scrollingtableyznd "
        style="top: 544px; left: 1489px;position: absolute; width: 398px; height: 186px; transform: translate(0px, 0px); z-index: 1018;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;height:190px;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <scrollingtable _tmplitem="232" :header-row-style="{ 'font-size': '12px', 'line-height': '40px' }"
            :row-style="{ 'font-size': '12px', 'line-height': '40px' }" :isheadshow="true" :showordernum="false"
            :scrollnum="3" tablebackgroundcolor="" tableheadcolor="rgba(0, 186, 255, 0.25)"
            tablerowhovercolor="rgba(0, 59, 81, 0.3)" tablerowcolor="rgba(10, 39, 50, 0.3)"
            tablerowdoublecolor="rgba(0, 59, 81, 0.3)" tablebordercolor="#42669a" tableheadfontcolor="#fff"
            tablehoverfontcolor="#fff" tablerowfontcolor="#fff" :scrollheight="1" :scrolltime="25"
            :elcolumn="controlData.scrollingtableyznd" :tabledata="fromData.scrollingtableyznd" :h="186" :w="398">
          </scrollingtable>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.scrollingtable8roe" class="bigitem scrollingtable8roe "
        style="top: 794px; left: 1491px;position: absolute; width: 398px; height: 260px; transform: translate(0px, 0px); z-index: 1017;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;height:190px;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <scrollingtable _tmplitem="233" :header-row-style="{ 'font-size': '12px', 'line-height': '40px' }"
            :row-style="{ 'font-size': '12px', 'line-height': '40px' }" :isheadshow="true" :showordernum="false"
            :scrollnum="3" tablebackgroundcolor="" tableheadcolor="rgba(0, 186, 255, 0.25)"
            tablerowhovercolor="rgba(0, 59, 81, 0.3)" tablerowcolor="rgba(10, 39, 50, 0.3)"
            tablerowdoublecolor="rgba(0, 59, 81, 0.3)" tablebordercolor="#42669a" tableheadfontcolor="#fff"
            tablehoverfontcolor="#fff" tablerowfontcolor="#fff" :scrollheight="1" :scrolltime="25"
            :elcolumn="controlData.scrollingtable8roe" :tabledata="fromData.scrollingtable8roe" :h="260" :w="398">
          </scrollingtable>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.chartbyub" class="bigitem chartbyub bigechartitem"
        style="top: 141px; left: 1475px;position: absolute; width: 414px; height: 270px; transform: translate(0px, 0px); z-index: 1016;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <myechart _tmplitem="234" ref="chartbyub" orienttype="horizontal" :echartroll="false" :maxechartrollnum="8"
            :echartrolltime="2" mapcity="" mapcode="" mapurl="" :options="fromData.chartbyub"></myechart>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.charthupa" class="bigitem charthupa bigechartitem"
        style="top: 789px; left: 480px;position: absolute; width: 964px; height: 260px; transform: translate(0px, 0px); z-index: 1015;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <myechart _tmplitem="235" ref="charthupa" orienttype="horizontal" :echartroll="false" :maxechartrollnum="8"
            :echartrolltime="2" mapcity="" mapcode="" mapurl="" :options="fromData.charthupa"></myechart>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.scrollingtablea8lp" class="bigitem scrollingtablea8lp "
        style="top: 800px; left: 31px;position: absolute; width: 408px; height: 249px; transform: translate(0px, 0px); z-index: 1014;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;height:190px;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <scrollingtable _tmplitem="236" :header-row-style="{ 'font-size': '12px', 'line-height': '40px' }"
            :row-style="{ 'font-size': '12px', 'line-height': '40px' }" :isheadshow="true" :showordernum="false"
            :scrollnum="3" tablebackgroundcolor="" tableheadcolor="rgba(0, 186, 255, 0.25)"
            tablerowhovercolor="rgba(0, 59, 81, 0.3)" tablerowcolor="rgba(10, 39, 50, 0.3)"
            tablerowdoublecolor="rgba(0, 59, 81, 0.3)" tablebordercolor="#42669a" tableheadfontcolor="#fff"
            tablehoverfontcolor="#fff" tablerowfontcolor="#fff" :scrollheight="1" :scrolltime="25"
            :elcolumn="controlData.scrollingtablea8lp" :tabledata="fromData.scrollingtablea8lp" :h="249" :w="408">
          </scrollingtable>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.charttoolxhof" class="bigitem charttoolxhof "
        style="top: 489px; left: 33px;position: absolute; width: 402px; height: 245px; transform: translate(0px, 0px); z-index: 1013;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <baseechart _tmplitem="237" ref="charttoolxhof" :val="fromData.charttoolxhof" mapcity="" mapcode=""
            orienttype="horizontal" :echartroll="false" :maxechartrollnum="8" :echartrolltime="2"
            :configechart="controlData.charttoolxhof" :w="402" :h="245" echartcode="widgetPiechart"></baseechart>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.charttoolohgm" class="bigitem charttoolohgm "
        style="top: 158px; left: 38px;position: absolute; width: 404px; height: 251px; transform: translate(0px, 0px); z-index: 1012;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <baseechart _tmplitem="238" ref="charttoolohgm" :val="fromData.charttoolohgm" mapcity="" mapcode=""
            orienttype="horizontal" :echartroll="false" :maxechartrollnum="8" :echartrolltime="2"
            :configechart="controlData.charttoolohgm" :w="404" :h="251" echartcode="widgetLineStack"></baseechart>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.borderBox12xgq0" class="bigitem borderBox12xgq0 "
        style="top: 780px; left: 463px;position: absolute; width: 996px; height: 283px; transform: translate(0px, 0px); z-index: 1011;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <dv-border-box-12 style="width:996px;height:283px" :color="[]"></dv-border-box-12>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.borderBox12crma" class="bigitem borderBox12crma "
        style="top: 134px; left: 1475px;position: absolute; width: 420px; height: 285px; transform: translate(0px, 0px); z-index: 1010;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <dv-border-box-12 style="width:420px;height:285px" :color="[]"></dv-border-box-12>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.borderBox125b7v" class="bigitem borderBox125b7v "
        style="top: 455px; left: 1479px;position: absolute; width: 420px; height: 285px; transform: translate(0px, 0px); z-index: 109;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <dv-border-box-12 style="width:420px;height:285px" :color="[]"></dv-border-box-12>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.borderBox12f12y" class="bigitem borderBox12f12y "
        style="top: 776px; left: 1476px;position: absolute; width: 420px; height: 285px; transform: translate(0px, 0px); z-index: 108;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <dv-border-box-12 style="width:420px;height:285px" :color="[]"></dv-border-box-12>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.borderBox12b0c0" class="bigitem borderBox12b0c0 "
        style="top: 776px; left: 23px;position: absolute; width: 420px; height: 285px; transform: translate(0px, 0px); z-index: 107;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <dv-border-box-12 style="width:420px;height:285px" :color="[]"></dv-border-box-12>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.borderBox128c06" class="bigitem borderBox128c06 "
        style="top: 457px; left: 27px;position: absolute; width: 420px; height: 285px; transform: translate(0px, 0px); z-index: 106;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <dv-border-box-12 style="width:420px;height:285px" :color="[]"></dv-border-box-12>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.borderBox12azrc" class="bigitem borderBox12azrc "
        style="top: 134px; left: 30px;position: absolute; width: 420px; height: 285px; transform: translate(0px, 0px); z-index: 105;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <dv-border-box-12 style="width:420px;height:285px" :color="[]"></dv-border-box-12>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.datetimerq0z" class="bigitem datetimerq0z "
        style="top: 30px; left: 1612px;position: absolute; width: 300px; height: 36px; transform: translate(0px, 0px); z-index: 104;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:14px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;text-align:left;font-family:'Microsoft YaHei';line-height:40px ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <comdatetime _tmplitem="246" ref="datetimerq0z" w="300" h="36" format="YYYY年MM月DD HH:mm:ss" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:14px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;text-align:left;font-family:'Microsoft YaHei';line-height:40px ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);    color: rgb(255, 255, 255);
  height: 36px;
  font-size: 24px;
  text-align: left;
  font-family: AlimamaAgileVF-Thin;
  font-weight: bold;
  line-height: 34px;"></comdatetime>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.weatherjpx9" class="bigitem weatherjpx9 "
        style="top: 26px; left: 40px;position: absolute; width: 300px; height: 38px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:26px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <weather _tmplitem="247" citycode="430100" fontsize="26" amapkey=""
            stylecss="--animation-linear:1;--animation-type:ease;opacity:1;font-size:26px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          </weather>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.grop5qtl" class="grop5qtl "
        style="overflow: hidden; width: 1920px; height: 224px;top: 0px; left: 0px;position: absolute; z-index: 102;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="252" class=""
          style=" width: 1920px; height: 224px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="250" v-if="readDataPermission.img5bsx" class="bigitem img5bsx "
            style="top: 0px; left: 0px; position: absolute;width: 1920px; height: 224px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="250" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="248" url="/img1948914776579035137/ec69e475-1001-409f-951b-834374a2f22b.png" w="1920"
                h="224" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
          <div _tmplitem="250" v-if="readDataPermission.title69cq" class="bigitem title69cq "
            style="top: 34px; left: 731px; position: absolute;width: 432px; height: 50px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="250" class="itemcontent "
              style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:32px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="249" ref="title69cq" :w="432" :h="50" :val="fromData.title69cq" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:32px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);color: rgb(255, 255, 255);
  text-align: center;
"></titlecontrol>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="252" v-if="readDataPermission.backgroundunit1354ql" class="bigitem backgroundunit1354ql "
        style="top: 471px; left: 457px;position: absolute; width: 1042px; height: 484px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
        <div _tmplitem="252" class="itemcontent "
          style="--animation-linear:1;--animation-type:ease;opacity:1;transform:  rotateX(-77deg) rotateY(0deg) rotateZ(0deg);">
          <backgroundunit13 _tmplitem="251" :w="1042" :h="484" stroke="#19e5e6"></backgroundunit13>
        </div>
      </div>
    </div>
    <fromdialog _tmplitem="252" ref="reffromdialog"></fromdialog>
  </div>
</template>
<script>
import map430000 from './map430000.json'
import * as echarts from 'echarts'
import vuecommq1ys from './vuecommq1ys.vue'
import custom1948972425559461890 from './custom1948972425559461890.vue'
export default {
  methods: {
    created_sys() {
      ///系统方法 判断页面大小 使其自动适应
      let $this = this
      this.w = this.w === undefined ? 1920 : this.w
      $this.css = $this.fullScreenCss($this, this.screentype)
      window.addEventListener('resize', () => {
        $this.css = $this.fullScreenCss($this, this.screentype)
      })
      if (this.loadfunmounted_sys !== undefined) {
        this.$nextTick(() => {
          this.loadfunmounted_sys()
        })
      }
    },
    // [undefinedloadfunmounted]事件方法
    loadfunmounted() { },
    loadsysmounted() {
      echarts.registerMap('430000', map430000)
    },
    fullScreenCss(t, e) {
      if ('none' === e)
        return `  width: ${t.w}px;height: ${t.h}px; ${'' === t.bg
            ? ''
            : 'background-image:url(' +
            t.bg +
            ');    background-repeat: no-repeat;background-size: cover;'
          }    ${'' === t.bgColor ? '' : 'background-color:' + t.bgColor + ';'}`
      if ('w' === e)
        return `  width: ${t.w}px;height: ${t.h}px; ${'' === t.bg
            ? ''
            : 'background-image:url(' +
            t.bg +
            ');    background-repeat: no-repeat;background-size: cover;'
          }  transform: scale(${document.body.clientWidth / t.w});  ${'' === t.bgColor ? '' : 'background-color:' + t.bgColor + ';'
          }`
      if ('h' === e)
        return `  width: ${t.w}px;height: ${t.h}px; ${'' === t.bg
            ? ''
            : 'background-image:url(' +
            t.bg +
            ');    background-repeat: no-repeat;background-size: cover;'
          }  transform: scale(${document.body.clientHeight / t.h});  ${'' === t.bgColor ? '' : 'background-color:' + t.bgColor + ';'
          }`
      if ('full' === e)
        return `  width: ${t.w}px;height: ${t.h}px; ${'' === t.bg
            ? ''
            : 'background-image:url(' +
            t.bg +
            ');    background-repeat: no-repeat;background-size: cover;'
          }  transform: scale(${document.body.clientWidth / t.w},${document.body.clientHeight /
          t.h});  ${'' === t.bgColor ? '' : 'background-color:' + t.bgColor + ';'}`
      {
        let e = document.body.clientHeight / t.h,
          n = document.body.clientWidth / t.w,
          i = e > n ? n : e,
          o = (document.body.clientWidth - i * t.w) / 2
        return (
          (o = o > 0 ? 'left:' + o + 'px;' : ''),
          o +
          ` transform: scale(${i}); width: ${t.w}px;height: ${t.h}px; ${'' === t.bg
            ? ''
            : 'background-image:url(' +
            t.bg +
            ');    background-repeat: no-repeat;background-size: cover;'
          } ${'' === t.bgColor ? '' : 'background-color:' + t.bgColor + ';'}`
        )
      }
    },
    loadfunmounted_sys() {
      if (this.loadsysmounted !== undefined) {
        this.loadsysmounted()
      }
      if (this.loadfunmounted !== undefined) {
        let isreturn = this.loadfunmounted()
        if (isreturn == false) {
          return
        }
      }
    },
  },
  created() {
    this.created_sys()
  },
  data() {
    return {
      w: 1920,
      css: ``,
      h: 1080,
      bg: `/img1948914776579035137/charts-img-db_id_2p0mcnzpe7i000.jpg`,
      bgColor: ``,
      fromData: {
        numlhg9: 4600,
        titlehn3l: `公路`,
        nummeaj: 7890,
        titlea1v3: `铁路`,
        titledhj5: `5 号仓库`,
        title1cpv: `3 号仓库`,
        titles9l7: `年度指标`,
        numbgm8: 78,
        titlezx47: `年度指标`,
        numqj42: 960,
        chartla3c: {
          title: {
            text: `16%`,
            subtext: `进度`,
            x: `center`,
            y: `center`,
            textStyle: {
              color: `rgb(0 238 255)`,
              fontSize: 30,
              fontWeight: `normal`,
            },
            subtextStyle: {
              color: `#fff`,
              fontSize: 14,
              fontWeight: `normal`,
            },
          },
          tooltip: {
            trigger: `item`,
            formatter: `{a} <br/>{b} : {c} ({d}%)`,
          },
          legend: {
            x: `center`,
            y: `bottom`,
            data: [`rose3`, `rose5`, `rose6`, `rose7`, `rose8`],
          },
          calculable: true,
          series: [
            {
              name: `面积模式`,
              type: `pie`,
              radius: [`80%`, `90%`],
              center: [`50%`, `50%`],
              data: [
                {
                  value: 34,
                  name: `吴际帅
牛亚莉`,
                  itemStyle: {
                    color: {
                      colorStops: [
                        {
                          offset: 0,
                          color: `#f6e3a1`,
                        },
                        {
                          offset: 1,
                          color: `#ff4236`,
                        },
                      ],
                      x: 0,
                      y: 1,
                      x2: 0,
                      y2: 0,
                      type: `linear`,
                      global: false,
                    },
                  },
                  label: {
                    color: `rgba(255,255,255,.45)`,
                    fontSize: 14,
                    formatter: `完成梳理部门
{a|34}个`,
                    rich: {
                      a: {
                        color: `#fff`,
                        fontSize: 20,
                        lineHeight: 30,
                      },
                    },
                  },
                },
                {
                  value: 52,
                  name: `rose2`,
                  itemStyle: {
                    color: `transparent`,
                  },
                },
              ],
            },
            {
              name: `面积模式`,
              type: `pie`,
              radius: [`80%`, `90%`],
              center: [`50%`, `50%`],
              data: [
                {
                  value: 34,
                  name: `吴际帅
牛亚莉`,
                  itemStyle: {
                    color: `transparent`,
                  },
                },
                {
                  value: 52,
                  name: `rose2`,
                  itemStyle: {
                    color: {
                      colorStops: [
                        {
                          offset: 0,
                          color: `#348fe6`,
                        },
                        {
                          offset: 1,
                          color: `#625bef`,
                        },
                      ],
                      x: 0,
                      y: 1,
                      x2: 0,
                      y2: 0,
                      type: `linear`,
                      global: false,
                    },
                  },
                  label: {
                    color: `rgba(255,255,255,.45)`,
                    fontSize: 14,
                    formatter: `部门总量
{a|52}个`,
                    rich: {
                      a: {
                        color: `#fff`,
                        fontSize: 20,
                        lineHeight: 30,
                      },
                    },
                  },
                },
              ],
            },
          ],
        },
        title1ca8: `年度指标`,
        num7zmh: 1200,
        chartsrkm: {
          title: {
            text: `84%`,
            subtext: `产能利用率`,
            x: `center`,
            y: `center`,
            textStyle: {
              color: `rgb(0 238 255)`,
              fontSize: 30,
              fontWeight: `normal`,
            },
            subtextStyle: {
              color: `#fff`,
              fontSize: 14,
              fontWeight: `normal`,
            },
          },
          tooltip: {
            trigger: `item`,
            formatter: `{a} <br/>{b} : {c} ({d}%)`,
          },
          legend: {
            x: `center`,
            y: `bottom`,
            data: [`rose3`, `rose5`, `rose6`, `rose7`, `rose8`],
          },
          calculable: true,
          series: [
            {
              name: `面积模式`,
              type: `pie`,
              radius: [`80%`, `90%`],
              center: [`50%`, `50%`],
              data: [
                {
                  value: 34,
                  name: `吴际帅
牛亚莉`,
                  itemStyle: {
                    color: {
                      colorStops: [
                        {
                          offset: 0,
                          color: `#f6e3a1`,
                        },
                        {
                          offset: 1,
                          color: `#ff4236`,
                        },
                      ],
                      x: 0,
                      y: 1,
                      x2: 0,
                      y2: 0,
                      type: `linear`,
                      global: false,
                    },
                  },
                  label: {
                    color: `rgba(255,255,255,.45)`,
                    fontSize: 14,
                    formatter: `完成梳理部门
{a|34}个`,
                    rich: {
                      a: {
                        color: `#fff`,
                        fontSize: 20,
                        lineHeight: 30,
                      },
                    },
                  },
                },
                {
                  value: 52,
                  name: `rose2`,
                  itemStyle: {
                    color: `transparent`,
                  },
                },
              ],
            },
            {
              name: `面积模式`,
              type: `pie`,
              radius: [`80%`, `90%`],
              center: [`50%`, `50%`],
              data: [
                {
                  value: 34,
                  name: `吴际帅
牛亚莉`,
                  itemStyle: {
                    color: `transparent`,
                  },
                },
                {
                  value: 52,
                  name: `rose2`,
                  itemStyle: {
                    color: {
                      colorStops: [
                        {
                          offset: 0,
                          color: `#348fe6`,
                        },
                        {
                          offset: 1,
                          color: `#625bef`,
                        },
                      ],
                      x: 0,
                      y: 1,
                      x2: 0,
                      y2: 0,
                      type: `linear`,
                      global: false,
                    },
                  },
                  label: {
                    color: `rgba(255,255,255,.45)`,
                    fontSize: 14,
                    formatter: `部门总量
{a|52}个`,
                    rich: {
                      a: {
                        color: `#fff`,
                        fontSize: 20,
                        lineHeight: 30,
                      },
                    },
                  },
                },
              ],
            },
          ],
        },
        chart7ytr: {
          title: {
            text: `74%`,
            subtext: `库存周转率`,
            x: `center`,
            y: `center`,
            textStyle: {
              color: `rgb(0 238 255)`,
              fontSize: 30,
              fontWeight: `normal`,
            },
            subtextStyle: {
              color: `#fff`,
              fontSize: 14,
              fontWeight: `normal`,
            },
          },
          tooltip: {
            trigger: `item`,
            formatter: `{a} <br/>{b} : {c} ({d}%)`,
          },
          legend: {
            x: `center`,
            y: `bottom`,
            data: [`rose3`, `rose5`, `rose6`, `rose7`, `rose8`],
          },
          calculable: true,
          series: [
            {
              name: `面积模式`,
              type: `pie`,
              radius: [`80%`, `90%`],
              center: [`50%`, `50%`],
              data: [
                {
                  value: 34,
                  name: `吴际帅
牛亚莉`,
                  itemStyle: {
                    color: {
                      colorStops: [
                        {
                          offset: 0,
                          color: `#f6e3a1`,
                        },
                        {
                          offset: 1,
                          color: `#ff4236`,
                        },
                      ],
                      x: 0,
                      y: 1,
                      x2: 0,
                      y2: 0,
                      type: `linear`,
                      global: false,
                    },
                  },
                  label: {
                    color: `rgba(255,255,255,.45)`,
                    fontSize: 14,
                    formatter: `完成梳理部门
{a|34}个`,
                    rich: {
                      a: {
                        color: `#fff`,
                        fontSize: 20,
                        lineHeight: 30,
                      },
                    },
                  },
                },
                {
                  value: 52,
                  name: `rose2`,
                  itemStyle: {
                    color: `transparent`,
                  },
                },
              ],
            },
            {
              name: `面积模式`,
              type: `pie`,
              radius: [`80%`, `90%`],
              center: [`50%`, `50%`],
              data: [
                {
                  value: 34,
                  name: `吴际帅
牛亚莉`,
                  itemStyle: {
                    color: `transparent`,
                  },
                },
                {
                  value: 52,
                  name: `rose2`,
                  itemStyle: {
                    color: {
                      colorStops: [
                        {
                          offset: 0,
                          color: `#348fe6`,
                        },
                        {
                          offset: 1,
                          color: `#625bef`,
                        },
                      ],
                      x: 0,
                      y: 1,
                      x2: 0,
                      y2: 0,
                      type: `linear`,
                      global: false,
                    },
                  },
                  label: {
                    color: `rgba(255,255,255,.45)`,
                    fontSize: 14,
                    formatter: `部门总量
{a|52}个`,
                    rich: {
                      a: {
                        color: `#fff`,
                        fontSize: 20,
                        lineHeight: 30,
                      },
                    },
                  },
                },
              ],
            },
          ],
        },
        charttoolgybg: [
          {
            source: `长沙市`,
            target: `衡阳市`,
            value: 95,
          },
          {
            source: `长沙市`,
            target: `株洲市`,
            value: 90,
          },
          {
            source: `长沙市`,
            target: `湘潭市`,
            value: 80,
          },
          {
            source: `长沙市`,
            target: `常德市`,
            value: 70,
          },
          {
            source: `长沙市`,
            target: `邵阳市`,
            value: 60,
          },
          {
            source: `长沙市`,
            target: `益阳市`,
            value: 50,
          },
          {
            source: `长沙市`,
            target: `岳阳市`,
            value: 40,
          },
          {
            source: `长沙市`,
            target: `郴州市`,
            value: 30,
          },
          {
            source: `长沙市`,
            target: `永州市`,
            value: 20,
          },
          {
            source: `长沙市`,
            target: `张家界市`,
            value: 10,
          },
          {
            source: `长沙市`,
            target: `怀化市`,
            value: 10,
          },
          {
            source: `长沙市`,
            target: `娄底市`,
            value: 10,
          },
        ],
        scrollingtableyznd: [
          {
            date: `鞋子`,
            name: `产线1`,
            address: `1100`,
          },
          {
            date: `鞋子`,
            name: `产线1`,
            address: `1100`,
          },
          {
            date: `鞋子`,
            name: `产线1`,
            address: `1100`,
          },
          {
            date: `鞋子`,
            name: `产线1`,
            address: `1100`,
          },
          {
            date: `鞋子`,
            name: `产线1`,
            address: `1100`,
          },
          {
            date: `鞋子`,
            name: `产线1`,
            address: `1100`,
          },
          {
            date: `鞋子`,
            name: `产线1`,
            address: `1100`,
          },
        ],
        scrollingtable8roe: [
          {
            date: `鞋子`,
            name: `产线1`,
            address: `1100`,
          },
          {
            date: `鞋子`,
            name: `产线1`,
            address: `1100`,
          },
          {
            date: `鞋子`,
            name: `产线1`,
            address: `1100`,
          },
          {
            date: `鞋子`,
            name: `产线1`,
            address: `1100`,
          },
          {
            date: `鞋子`,
            name: `产线1`,
            address: `1100`,
          },
          {
            date: `鞋子`,
            name: `产线1`,
            address: `1100`,
          },
          {
            date: `鞋子`,
            name: `产线1`,
            address: `1100`,
          },
        ],
        chartbyub: {
          series: [
            {
              name: `水球图`,
              type: `liquidFill`,
              radius: `45%`,
              center: [`25%`, `40%`],
              waveAnimation: 10,
              amplitude: 5,
              data: [0.6, 0.5],
              itemStyle: {
                normal: {
                  color: {
                    colorStops: [
                      {
                        offset: 0,
                        color: `#38D884`,
                      },
                      {
                        offset: 1,
                        color: `#17B9C2`,
                      },
                    ],
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    type: `linear`,
                    global: false,
                  },
                },
              },
              color: {
                type: `linear`,
                x: 0,
                y: 0,
                x2: 1,
                y2: 1,
                colorStops: [
                  {
                    offset: 1,
                    color: `#38D884`,
                  },
                  {
                    offset: 0,
                    color: `#17B9C2`,
                  },
                ],
                globalCoord: false,
              },
              label: {
                normal: {
                  textStyle: {
                    color: `#ffffff`,
                    insideColor: `#ffffff`,
                    fontSize: 13,
                  },
                },
              },
              outline: {
                show: true,
                borderDistance: 0,
                itemStyle: {
                  borderWidth: 2,
                  borderColor: {
                    type: `linear`,
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: `#38D884`,
                      },
                      {
                        offset: 1,
                        color: `#17B9C2`,
                      },
                    ],
                    globalCoord: false,
                  },
                },
              },
              backgroundStyle: {
                color: `#58A0AD`,
              },
            },
            {
              name: `水球图`,
              type: `liquidFill`,
              radius: `45%`,
              center: [`80%`, `40%`],
              waveAnimation: 10,
              amplitude: 5,
              data: [0.6, 0.5],
              itemStyle: {
                normal: {
                  color: {
                    colorStops: [
                      {
                        offset: 0,
                        color: `#F8862C`,
                      },
                      {
                        offset: 1,
                        color: `#FA5E56`,
                      },
                    ],
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    type: `linear`,
                    global: false,
                  },
                },
              },
              color: {
                type: `linear`,
                x: 0,
                y: 0,
                x2: 1,
                y2: 1,
                colorStops: [
                  {
                    offset: 1,
                    color: `rgba(248, 134, 44, 1)`,
                  },
                  {
                    offset: 0,
                    color: `rgba(250, 94, 86, 1)`,
                  },
                ],
                globalCoord: false,
              },
              label: {
                normal: {
                  textStyle: {
                    color: `#ffffff`,
                    insideColor: `#ffffff`,
                    fontSize: 13,
                  },
                },
              },
              outline: {
                show: true,
                borderDistance: 0,
                itemStyle: {
                  borderWidth: 2,
                  borderColor: {
                    type: `linear`,
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: `rgba(248, 134, 44, 1)`,
                      },
                      {
                        offset: 1,
                        color: `rgba(250, 94, 86, 1)`,
                      },
                    ],
                    globalCoord: false,
                  },
                },
              },
              backgroundStyle: {
                color: `#8D8690`,
              },
            },
          ],
        },
        charthupa: {
          grid: {
            left: `5%`,
            right: `10%`,
            top: `20%`,
            bottom: `15%`,
            containLabel: true,
          },
          tooltip: {
            show: true,
            trigger: `item`,
          },
          legend: {
            show: true,
            x: `center`,
            y: `35`,
            icon: `stack`,
            itemWidth: 10,
            itemHeight: 10,
            textStyle: {
              color: `#1bb4f6`,
            },
            data: [`已采纳`, `已发布`, `浏览量`],
          },
          xAxis: [
            {
              type: `category`,
              boundaryGap: false,
              axisLabel: {
                color: `#30eee9`,
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: `#397cbc`,
                },
              },
              axisTick: {
                show: false,
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: `#195384`,
                },
              },
              data: [
                `2020-02-25 16:22:41`,
                `2020-02-25 16:23:11`,
                `2020-02-25 16:23:41`,
                `2020-02-25 16:24:11`,
                `2020-02-25 16:24:41`,
              ],
            },
          ],
          yAxis: [
            {
              type: `value`,
              axisLabel: {
                formatter: `{value}`,
                textStyle: {
                  color: `#2ad1d2`,
                },
              },
              axisLine: {
                lineStyle: {
                  color: `#27b4c2`,
                },
              },
              axisTick: {
                show: false,
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: `#11366e`,
                },
              },
            },
          ],
          series: [
            {
              name: `已采纳`,
              type: `line`,
              stack: `总量`,
              symbol: `circle`,
              symbolSize: 8,
              itemStyle: {
                normal: {
                  color: `#0092f6`,
                  lineStyle: {
                    color: `#0092f6`,
                    width: 1,
                  },
                  areaStyle: {
                    color: {
                      colorStops: [
                        {
                          offset: 0,
                          color: `rgba(7,44,90,0.3)`,
                        },
                        {
                          offset: 1,
                          color: `rgba(0,146,246,0.9)`,
                        },
                      ],
                      x: 0,
                      y: 1,
                      x2: 0,
                      y2: 0,
                      type: `linear`,
                      global: false,
                    },
                  },
                },
              },
              markPoint: {
                itemStyle: {
                  normal: {
                    color: `red`,
                  },
                },
              },
              data: [9, 3, 5, 3, 2],
            },
            {
              name: `已发布`,
              type: `line`,
              stack: `总量`,
              symbol: `circle`,
              symbolSize: 8,
              itemStyle: {
                normal: {
                  color: `#00d4c7`,
                  lineStyle: {
                    color: `#00d4c7`,
                    width: 1,
                  },
                  areaStyle: {
                    color: {
                      colorStops: [
                        {
                          offset: 0,
                          color: `rgba(7,44,90,0.3)`,
                        },
                        {
                          offset: 1,
                          color: `rgba(0,212,199,0.9)`,
                        },
                      ],
                      x: 0,
                      y: 1,
                      x2: 0,
                      y2: 0,
                      type: `linear`,
                      global: false,
                    },
                  },
                },
              },
              data: [1, 3, 6, 5, 2],
            },
            {
              name: `浏览量`,
              type: `line`,
              stack: `总量`,
              symbol: `circle`,
              symbolSize: 8,
              itemStyle: {
                normal: {
                  color: `#aecb56`,
                  lineStyle: {
                    color: `#aecb56`,
                    width: 1,
                  },
                  areaStyle: {
                    color: {
                      colorStops: [
                        {
                          offset: 0,
                          color: `rgba(7,44,90,0.3)`,
                        },
                        {
                          offset: 1,
                          color: `rgba(114,144,89,0.9)`,
                        },
                      ],
                      x: 0,
                      y: 1,
                      x2: 0,
                      y2: 0,
                      type: `linear`,
                      global: false,
                    },
                  },
                },
              },
              data: [1, 2, 3, 4, 7],
            },
          ],
        },
        scrollingtablea8lp: [
          {
            date: `鞋子`,
            name: `产线1`,
            address: `1100`,
          },
          {
            date: `鞋子`,
            name: `产线1`,
            address: `1100`,
          },
          {
            date: `鞋子`,
            name: `产线1`,
            address: `1100`,
          },
          {
            date: `鞋子`,
            name: `产线1`,
            address: `1100`,
          },
          {
            date: `鞋子`,
            name: `产线1`,
            address: `1100`,
          },
          {
            date: `鞋子`,
            name: `产线1`,
            address: `1100`,
          },
          {
            date: `鞋子`,
            name: `产线1`,
            address: `1100`,
          },
        ],
        charttoolxhof: [
          {
            value: 1048,
            name: `搜索引擎`,
          },
          {
            value: 735,
            name: `直接访问`,
          },
          {
            value: 580,
            name: `邮件营销`,
          },
          {
            value: 484,
            name: `联盟广告`,
          },
          {
            value: 300,
            name: `视频广告`,
          },
        ],
        charttoolohgm: [
          {
            axis: `2021-07-25`,
            name: `A`,
            data: `12`,
          },
          {
            axis: `2021-07-25`,
            name: `B`,
            data: `20`,
          },
          {
            axis: `2021-07-26`,
            name: `B`,
            data: `5`,
          },
          {
            axis: `2021-07-26`,
            name: `A`,
            data: `5`,
          },
          {
            axis: `2021-07-27`,
            name: `A`,
            data: `15`,
          },
          {
            axis: `2021-07-27`,
            name: `B`,
            data: `30`,
          },
          {
            axis: `2021-07-28`,
            name: `A`,
            data: `15`,
          },
          {
            axis: `2021-07-28`,
            name: `B`,
            data: `30`,
          },
          {
            axis: `2021-07-29`,
            name: `A`,
            data: `15`,
          },
          {
            axis: `2021-07-29`,
            name: `B`,
            data: `30`,
          },
        ],
        title69cq: `生产运营中心数据可视化`,
      },
      controlTimer: {},
      controlData: {
        charttoolgybg: {
          mapName: [`china`, `430000`],
          isShowTitle: true,
          text: ``,
          textColor: ``,
          textFontSize: 20,
          textFontWeight: `normal`,
          textFontStyle: `normal`,
          textFontFamily: `sans-serif`,
          subtext: ``,
          subtextColor: ``,
          subtextFontSize: 20,
          subtextFontWeight: `normal`,
          subtextFontStyle: `normal`,
          subtextFontFamily: `sans-serif`,
          titleLeft: `center`,
          titleTop: 5,
          titleItemGap: 0,
          isShowMap: false,
          fontSize: 12,
          fontColor: ``,
          fontWeight: `normal`,
          fontStyle: `normal`,
          fontFamily: `sans-serif`,
          fontColor0: `rgba(22, 238, 188, 0.2)`,
          fontColor100: `rgba(22, 238, 188, 1)`,
          borderWidth: 0,
          borderColor: `#fff`,
          borderType: `solid`,
          shadowColor: ``,
          shadowBlur: 10,
          opacity: 100,
          isShowEmphasisLabel: true,
          emphasisLabelFontSize: 12,
          emphasisLabelFontColor: `#D4EEFF`,
          emphasisLabelFontWeight: `normal`,
          emphasisLabelFontStyle: `normal`,
          emphasisLabelFontFamily: `sans-serif`,
          emphasisLabelFontColor0: `rgba(3, 247, 3, 0.2)`,
          emphasisLabelFontColor100: `rgba(3, 247, 3, 1)`,
          symbol: `plane`,
          symbolPeriod: 4,
          symbolSize: 10,
          symbolColor: `rgba(227, 59, 26, 1)`,
          lineColor: `#ffa022`,
          lineWidth: 2,
          isShowSource: true,
          sourceFontPosition: `top`,
          sourceSymbolSize: 10,
          sourcePointColor: `rgba(173, 21, 220, 1)`,
          sourceFontSize: 12,
          sourceFontColor: `rgba(224, 81, 29, 1)`,
          sourceFontTextWeight: `normal`,
          sourceFontStyle: `normal`,
          sourceFontFamily: `sans-serif`,
          isShowTarget: true,
          targetFontPosition: `inside`,
          targetSymbolSize: 10,
          targetPointColor: `rgba(233, 124, 70, 1)`,
          targetFontSize: 12,
          targetFontColor: `#46bee9`,
          targetFontWeight: `normal`,
          targetFontStyle: `normal`,
          targetFontFamily: `sans-serif`,
          isShowTooltip: true,
          tooltipFontSize: 16,
          tooltipColor: `rgba(50, 232, 13, 1)`,
          tooltipFontWeight: `normal`,
          tooltipFontStyle: `normal`,
          tooltipFontFamily: `sans-serif`,
          legendColor: ``,
          tipsColor: ``,
          textColorX: ``,
          textColorY: ``,
          lineColorY: ``,
          lineColorX: ``,
          mapcode: `430000`,
        },
        scrollingtableyznd: [
          {
            prop: `date`,
            label: `商品`,
            width: ``,
            align: ``,
            headeralign: ``,
            classname: ``,
            scopehtml: ``,
            minwidth: `80`,
            flexAlign: ``,
            showOverflowTooltip: false,
          },
          {
            prop: `name`,
            label: `产线`,
            width: ``,
            align: ``,
            headeralign: ``,
            classname: ``,
            scopehtml: ``,
            minwidth: `80`,
            flexAlign: ``,
            showOverflowTooltip: false,
          },
          {
            prop: `address`,
            label: `数量`,
            align: ``,
            headeralign: ``,
            classname: ``,
            scopehtml: ``,
            minwidth: ``,
            flexAlign: ``,
            showOverflowTooltip: false,
          },
        ],
        scrollingtable8roe: [
          {
            prop: `date`,
            label: `商品`,
            width: ``,
            align: ``,
            headeralign: ``,
            classname: ``,
            scopehtml: ``,
            minwidth: `80`,
            flexAlign: ``,
            showOverflowTooltip: false,
          },
          {
            prop: `name`,
            label: `产线`,
            width: ``,
            align: ``,
            headeralign: ``,
            classname: ``,
            scopehtml: ``,
            minwidth: `80`,
            flexAlign: ``,
            showOverflowTooltip: false,
          },
          {
            prop: `address`,
            label: `数量`,
            align: ``,
            headeralign: ``,
            classname: ``,
            scopehtml: ``,
            minwidth: ``,
            flexAlign: ``,
            showOverflowTooltip: false,
          },
        ],
        scrollingtablea8lp: [
          {
            prop: `date`,
            label: `商品`,
            width: ``,
            align: ``,
            headeralign: ``,
            classname: ``,
            scopehtml: ``,
            minwidth: `80`,
            flexAlign: ``,
            showOverflowTooltip: false,
          },
          {
            prop: `name`,
            label: `产线`,
            width: ``,
            align: ``,
            headeralign: ``,
            classname: ``,
            scopehtml: ``,
            minwidth: `80`,
            flexAlign: ``,
            showOverflowTooltip: false,
          },
          {
            prop: `address`,
            label: `数量`,
            align: ``,
            headeralign: ``,
            classname: ``,
            scopehtml: ``,
            minwidth: ``,
            flexAlign: ``,
            showOverflowTooltip: false,
          },
        ],
        charttoolxhof: {
          isShowTitle: true,
          text: ``,
          textColor: ``,
          textFontSize: 20,
          textFontWeight: `normal`,
          textFontStyle: `normal`,
          textFontFamily: `sans-serif`,
          subtext: ``,
          subtextColor: ``,
          subtextFontSize: 20,
          subtextFontWeight: `normal`,
          subtextFontStyle: `normal`,
          subtextFontFamily: `sans-serif`,
          titleLeft: `center`,
          titleTop: 5,
          titleItemGap: 0,
          innerNumber: 30,
          outerNumber: 60,
          clockwise: true,
          startAngle: 90,
          minAngle: 0,
          minShowLabelAngle: 0,
          borderRadius: 10,
          isShowEmphasisLabel: true,
          emphasisLabelFontSize: 24,
          emphasisLabelFontColor: ``,
          emphasisLabelFontWeight: `bold`,
          emphasisLabelFontStyle: `normal`,
          emphasisLabelFontFamily: `sans-serif`,
          borderColor: ``,
          borderWidth: 1,
          borderType: `solid`,
          shadowBlur: 10,
          shadowColor: `rgba(0, 0, 0, 0.5)`,
          isShowLegend: true,
          legendColor: `rgba(255, 255, 255, 1)`,
          legendFontSize: 12,
          legendFontWeight: `normal`,
          legendFontStyle: `normal`,
          legendFontFamily: `sans-serif`,
          legendWidth: 12,
          legendHeight: 12,
          lateralPosition: `right`,
          longitudinalPosition: `top`,
          layoutFront: `vertical`,
          isShow: true,
          numberValue: true,
          percentage: false,
          percentPrecision: 2,
          position: `outside`,
          padding: 0,
          rotate: 0,
          fontSize: 12,
          fontColor: ``,
          fontWeight: `normal`,
          fontStyle: `normal`,
          fontFamily: `sans-serif`,
          isShowLabelLine: true,
          labelLineSmooth: false,
          labelLineLength: 5,
          labelLineLength2: 15,
          lineStyleColor: ``,
          lineStyleWidth: 1,
          lineStyleType: `solid`,
          isShowTooltip: true,
          tooltipBackgroundColor: `#333`,
          tooltipFontSize: 16,
          tooltipColor: `#00FEFF`,
          tooltipFontWeight: `normal`,
          tooltipFontStyle: `normal`,
          tooltipFontFamily: `sans-serif`,
          tooltipBorderColor: `#333`,
          tooltipBorderWidth: 0,
          left: 0,
          right: 42,
          top: 0,
          bottom: 0,
          customColor: [
            {
              color: `rgb(73, 146, 255)`,
            },
            {
              color: `rgb(124, 255, 178)`,
            },
            {
              color: `rgb(253, 221, 96)`,
            },
            {
              color: `rgb(255, 110, 118)`,
            },
            {
              color: `rgb(88, 217, 249)`,
            },
            {
              color: `rgb(5, 192, 145)`,
            },
          ],
          tipsColor: ``,
          textColorX: ``,
          textColorY: ``,
          lineColorY: ``,
          lineColorX: ``,
        },
        charttoolohgm: {
          isShowTitle: true,
          text: ``,
          textColor: `rgba(252, 252, 252, 1)`,
          textFontSize: 20,
          textFontWeight: `normal`,
          textFontStyle: `normal`,
          textFontFamily: `sans-serif`,
          subtext: ``,
          subtextColor: ``,
          subtextFontSize: 20,
          subtextFontWeight: `normal`,
          subtextFontStyle: `normal`,
          subtextFontFamily: `sans-serif`,
          titleLeft: `center`,
          titleTop: 5,
          titleItemGap: 0,
          markPoint: true,
          pointSize: 12,
          symbol: `emptyCircle`,
          smoothCurve: true,
          lineWidth: 2,
          area: true,
          areaThickness: 14,
          isShowX: true,
          isShowAxisLabelX: true,
          positionX: `bottom`,
          offsetX: 0,
          textColorX: `rgba(254, 251, 251, 1)`,
          textFontSizeX: 14,
          textFontWeightX: `normal`,
          textFontStyleX: `normal`,
          textFontFamilyX: `sans-serif`,
          textRowsBreakAuto: false,
          textRowsNum: ``,
          textIntervalX: 0,
          textAngleX: 0,
          isShowAxisLineX: true,
          reversalX: false,
          lineColorX: `rgba(252, 250, 250, 1)`,
          lineWidthX: 1,
          nameX: ``,
          nameLocationX: `end`,
          nameColorX: `#fff`,
          nameFontSizeX: 14,
          nameFontWeightX: `normal`,
          nameFontStyleX: `normal`,
          nameFontFamilyX: `sans-serif`,
          isShowSplitLineX: false,
          splitLineColorX: `#fff`,
          splitLineWidthX: 1,
          isShowY: true,
          isShowAxisLabelY: true,
          maxY: ``,
          positionY: `left`,
          offsetY: 0,
          textColorY: `rgba(254, 254, 254, 1)`,
          textFontSizeY: 14,
          textFontWeightY: `normal`,
          textFontStyleY: `normal`,
          textFontFamilyY: `sans-serif`,
          scale: false,
          splitNumberY: 0,
          textAngleY: 0,
          isShowAxisLineY: true,
          reversalY: false,
          lineColorY: ``,
          lineWidthY: 1,
          textNameY: ``,
          nameLocationY: `end`,
          nameColorY: `#fff`,
          nameFontSizeY: 14,
          nameFontWeightY: `normal`,
          nameFontStyleY: `normal`,
          nameFontFamilyY: `sans-serif`,
          isShowSplitLineY: false,
          splitLineColorY: `#fff`,
          splitLineWidthY: 1,
          isShowLegend: true,
          legendName: `产线1|产线2`,
          legendColor: `rgba(244, 241, 241, 1)`,
          legendFontSize: 12,
          legendFontWeight: `normal`,
          legendFontStyle: `normal`,
          legendFontFamily: `sans-serif`,
          legendWidth: 12,
          legendHeight: 12,
          lateralPosition: `center`,
          longitudinalPosition: `top`,
          layoutFront: `horizontal`,
          isShow: false,
          percentSign: false,
          fontPosition: `top`,
          fontDistance: 0,
          fontColor: ``,
          fontSize: 12,
          fontWeight: `normal`,
          fontStyle: `normal`,
          fontFamily: `sans-serif`,
          isShowTooltip: true,
          tooltipTrigger: `axis`,
          tooltipAxisPointerType: `shadow`,
          tooltipFontSize: 16,
          tooltipColor: `#00FEFF`,
          tooltipFontWeight: `normal`,
          tooltipFontStyle: `normal`,
          tooltipFontFamily: `sans-serif`,
          marginLeft: 0,
          marginRight: 1,
          marginTop: 28,
          marginBottom: 10,
          customColor: [
            {
              color: `#047FF7`,
            },
            {
              color: `rgb(253, 221, 96)`,
            },
            {
              color: `rgb(255, 110, 118)`,
            },
            {
              color: `rgb(88, 217, 249)`,
            },
            {
              color: `rgb(5, 192, 145)`,
            },
          ],
          tipsColor: ``,
        },
      },
      screentype: `w`,
      readDataPermission: {
        numlhg9: true,
        nxiconsqa4l: true,
        titlehn3l: true,
        img9e6m: true,
        gropn3cq: true,
        nummeaj: true,
        img3r9a: true,
        titlea1v3: true,
        nxiconsjhwa: true,
        gropxcto: true,
        vuecommq1ys: true,
        titledhj5: true,
        title1cpv: true,
        customcotrlo3wt: true,
        customcotrlz5be: true,
        customcotrlq1yv: true,
        customcotrlhb2t: true,
        customcotrlbwjw: true,
        customcotrlhlag: true,
        labshoj: true,
        titles9l7: true,
        numbgm8: true,
        img2h99: true,
        group1832: true,
        titlezx47: true,
        numqj42: true,
        img3672: true,
        group3kyz: true,
        chartla3c: true,
        imgc765: true,
        gropaqh0: true,
        title1ca8: true,
        num7zmh: true,
        img2cck: true,
        groppfau: true,
        chartsrkm: true,
        imgxj87: true,
        gropnal7: true,
        imgxan0: true,
        chart7ytr: true,
        gropft9g: true,
        charttoolgybg: true,
        scrollingtableyznd: true,
        scrollingtable8roe: true,
        chartbyub: true,
        charthupa: true,
        scrollingtablea8lp: true,
        charttoolxhof: true,
        charttoolohgm: true,
        borderBox12xgq0: true,
        borderBox12crma: true,
        borderBox125b7v: true,
        borderBox12f12y: true,
        borderBox12b0c0: true,
        borderBox128c06: true,
        borderBox12azrc: true,
        datetimerq0z: true,
        weatherjpx9: true,
        img5bsx: true,
        title69cq: true,
        grop5qtl: true,
        backgroundunit1354ql: true,
      },
    }
  },
  components: {
    vuecommq1ys,
    custom1948972425559461890,
  },
}
</script>
<style scoped>
.dv-full-screen-container {
  transform: scale(1);
  position: absolute;
  top: 0px;
  left: 0px;
  overflow: hidden;
  transform-origin: left top;
  z-index: 499;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 1920px;
  height: 1080px;
  background-color: '#040404';
  background-size: cover;
  background-repeat: no-repeat;
}

.div-full-screen {
  background-size: cover;
  background-repeat: no-repeat;
}

.bigitem {
  position: absolute;
  will-change: transform;
}

.bigechartitem:hover {
  z-index: 1900 !important;
}

.layouttable {
  height: 100%;
  display: flex;
}

.layouttable .layouttable-item {
  height: 100%;
  position: relative;
  float: left;
}

.itemcontent {
  width: 100%;
  height: 100%;
}

.bigbutton {
  width: 100%;
  height: 100%;
  text-align: center;
}
</style>
<style scoped></style>
